import { render, staticRenderFns } from "./EmailPreferenceItem.vue?vue&type=template&id=f989b8ea&"
import script from "./EmailPreferenceItem.vue?vue&type=script&lang=js&"
export * from "./EmailPreferenceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports